import React, { ReactNode } from "react";

import { QueryProvider } from "src/components/providers/QueryProvider";
import { Provider as ReduxProvider } from "react-redux";

import "src/styles/global.css";
import { store } from "src/store";

type Props = {
  children: ReactNode;
};

export const Provider: React.FC<Props> = ({ children }) => (
  <QueryProvider>
    <ReduxProvider store={store}>{children}</ReduxProvider>
  </QueryProvider>
);
